import React from 'react';
import FiltersList from "./FiltersList";
import { Component, Position } from 'puzzle';
import { arrayMove } from "react-sortable-hoc";
import { FILTER, FILTERS_STATE } from './Types';
import { Container } from "puzzle";
import _ from "lodash";
import { getFavoritesFilterCount, pingForFavoritesFilterCount } from "../../util/Util";

class Filters extends Component<{}, FILTERS_STATE> {
  namespacePrefix = 'Filters';
  favoritesFilterCountIds: number[] = [];
  favoriteFilterUrl: string = '/filters/count';
  favoritesFilterCountProperty: string = 'submissionCount';
  /**
   * Prevent filter update state when component is unmounted
   */
  isComponentMounted: boolean = false;

  state: FILTERS_STATE = {
    filters: []
  };

  moduleDidMount = () => {
    this.isComponentMounted = true;
  };

  /**
   * Component will unmount
   * - stop pending ping for submission count
   */
  componentWillUnmount(): void {
    this.isComponentMounted = false;
    this.dispatch('stopPingingRequest', Position.end);
    super.componentWillUnmount();
  }

  loadFavoritedFilters = (filterData: any) => {
    this.favoritesFilterCountIds = _.filter(filterData, (filterItem: any) => !filterItem.submissionCount).map((filterItem: any) => filterItem.filterId);
    getFavoritesFilterCount(this);

    this.setState({
      filters: filterData
    });
  };

  onSortEnd = ({ oldIndex, newIndex }: any) => {
    const filters = arrayMove(this.state.filters, oldIndex, newIndex);
    this.setState({ filters });
    const params = filters.map(({ filterName }: FILTER, index: number) => {
      return { index, filterName }
    });
    this.dispatch('saveFavoriteFiltersSort', '', { params })
  };

  pingForFavoritesFilterCount = (responseData: any) => pingForFavoritesFilterCount(responseData, this);

  renderBody() {
    return (
      <Container className="tp-dashboard-filters" flex1>
        <FiltersList filters={this.state.filters} onSortEnd={this.onSortEnd} />
      </Container>
    );
  }
}

export default Filters;
